import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import axios from "axios";

const AuthContext = createContext(null);
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // Try admin session first, then customer session
    try {
      const r = await axios.get(`${BACKEND_URL}/api/auth/me`, { withCredentials: true });
      setUser(r.data);
      return;
    } catch {}
    try {
      const r = await axios.get(`${BACKEND_URL}/api/customer/me`, { withCredentials: true });
      setUser(r.data);
    } catch { setUser(false); }
  }, []);

  useEffect(() => {
    refresh().finally(() => setLoading(false));
  }, [refresh]);

  const login = useCallback(async (email, password) => {
    const r = await axios.post(`${BACKEND_URL}/api/auth/login`, { email, password }, { withCredentials: true });
    setUser(r.data);
    return r.data;
  }, []);

  const logout = useCallback(async () => {
    await axios.post(`${BACKEND_URL}/api/auth/logout`, {}, { withCredentials: true });
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, loading, login, logout, refresh }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const c = useContext(AuthContext);
  if (!c) throw new Error("useAuth needs AuthProvider");
  return c;
};
